import { createUseThemeHook } from 'legos/theme';
export const [AcpBiometricsThemeProvider, useAcpBiometricsTheme] = createUseThemeHook('acpBiometricsThemeProvider', global => ({
  lightDisclosureGreyColor: global.neutral.color500,
  neutralBlackColor: global.neutral.color800
}));